"use strict";
/**
 * @author Meiblorn (Vadim Fedorenko) <meiblorn@gmail.com | admin@meiblorn.com> on 15/05/16.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var mnFullpage_service_1 = require("./mnFullpage.service");
var mnFullpage_directive_1 = require("./mnFullpage.directive");
var MnFullpageModule = (function () {
    function MnFullpageModule() {
    }
    MnFullpageModule.forRoot = function () {
        return {
            ngModule: MnFullpageModule,
            providers: [mnFullpage_service_1.MnFullpageService]
        };
    };
    return MnFullpageModule;
}());
MnFullpageModule.decorators = [
    { type: core_1.NgModule, args: [{
                declarations: [mnFullpage_directive_1.MnFullpageDirective],
                exports: [mnFullpage_directive_1.MnFullpageDirective]
            },] },
];
/** @nocollapse */
MnFullpageModule.ctorParameters = function () { return []; };
exports.MnFullpageModule = MnFullpageModule;
//# sourceMappingURL=mnFullpage.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/ngx-fullpage/components/fullpage/mnFullpage.module.js
// module id = ../../../../ngx-fullpage/components/fullpage/mnFullpage.module.js
// module chunks = 4